import { fabric } from 'fabric';
import { CORNER_SIZE, CORNER_STROKE_WIDTH, FABRIC_CUSTOM_OBJECT, RECT } from '../../../utils';
import { EPS } from '../SwimLaneHorizontal';
import { editTextSwimLaneHorizontal } from './editText';

export const initialControl = {
  fill: 'transparent',
  originX: 'center',
  originY: 'center',
  isNotObj: true,
  isControlPoint: true,
  hasControls: false,
  hasBorders: false,
  hoverCursor: 'all-scroll',
  stroke: '#007aff',
  strokeWidth: CORNER_STROKE_WIDTH,
  width: CORNER_SIZE,
  height: CORNER_SIZE,
};

let eventOn = false;
let swimLane = null;
let onMouseDown;

const controlHeader = new fabric.Rect({ ...initialControl });

export const getSettings = () => {
  const zoom = window.canvas.getZoom();
  const settings = {
    width: CORNER_SIZE / zoom,
    height: CORNER_SIZE / zoom,
    strokeWidth: CORNER_STROKE_WIDTH / zoom,
    angle: 0,
    strokeDashArray: [],
  };
  return settings;
};

function controlSetCoords() {
  const { strokeWidth } = swimLane;
  const settings = getSettings();
  controlHeader.set({
    top: swimLane.top + swimLane.height / 2 + strokeWidth / 2,
    left: swimLane.left + swimLane.headerWidth + strokeWidth / 2,
    visible: swimLane.width > swimLane.headerWidth,
    ...settings,
  });
  controlHeader.setCoords();
}

function onMouseWheel() {
  controlSetCoords();
}

function onObjMoving(event) {
  const { canvas } = window;
  const { left, textStyle } = swimLane;
  const right = swimLane.left + swimLane.width;

  controlHeader.set({
    left: Math.min(Math.max(controlHeader.left, left + textStyle.height + EPS), right - EPS),
  });

  if (event.target === controlHeader) swimLane.set({ headerWidth: controlHeader.left - swimLane.left });

  swimLane.setCoords();
  canvas.remove(swimLane);
  swimLane = new fabric.SwimLaneHorizontal({ ...swimLane });
  canvas.add(swimLane);
  canvas.sendToBack(swimLane);
  controlSetCoords(controlHeader, swimLane);
}

function onMouseUp(event) {
  const { canvas } = window;
  swimLane.setCoords();
  canvas.remove(swimLane);
  swimLane = new fabric.SwimLaneHorizontal({ ...swimLane });
  canvas.add(swimLane);
  canvas.sendToBack(swimLane);
  window.canvas.remove(controlHeader);
  window.canvas.setActiveObject(swimLane);

  if (eventOn) {
    if (event.target && event.target === controlHeader) return;
    canvas.off('object:moving', onObjMoving);
    canvas.off('mouse:up', onMouseUp);
    canvas.off('mouse:down', onMouseDown);
    canvas.off('mouse:wheel', onMouseWheel);
    eventOn = false;
  }
  canvas.renderAll();
}

function addControl() {
  const { canvas } = window;
  window.canvas.add(controlHeader);
  if (!eventOn) {
    canvas.on('object:moving', onObjMoving);
    canvas.on('mouse:up', onMouseUp);
    canvas.on('mouse:down', onMouseDown);
    canvas.on('mouse:wheel', onMouseWheel);
    eventOn = true;
  }
}

export function deleteControl() {
  const { canvas } = window;
  window.canvas.remove(controlHeader);
  if (eventOn) {
    canvas.off('object:moving', onObjMoving);
    canvas.off('mouse:up', onMouseUp);
    canvas.off('mouse:down', onMouseDown);
    canvas.off('mouse:wheel', onMouseWheel);
    eventOn = false;
  }
}

onMouseDown = function (event) {
  let check = false;
  if (event.target?.isNotObj && event.target?.type === RECT) check = true;
  if (!check) deleteControl();
};

export function addingControlPointsSwimLaneHorizontal(target) {
  if (
    !target.type ||
    target.type !== FABRIC_CUSTOM_OBJECT.swimLaneHorizontal ||
    editTextSwimLaneHorizontal.object === target
  )
    return;
  swimLane = target;
  target.setCoords();
  controlSetCoords();
  controlHeader.set({
    lockMovementY: true,
  });
  addControl();
}

export const handleMouseDblClickSwimLaneHorizontal = (e) => {
  deleteControl();
  let { target } = e;
  if (!target || target.type !== FABRIC_CUSTOM_OBJECT.swimLaneHorizontal || editTextSwimLaneHorizontal.object) return;
  editTextSwimLaneHorizontal.myRect = new fabric.Rect({
    top: target.top + target.strokeWidth / 2 - target.headerStyle.strokeWidth / 2,
    left: target.left + target.strokeWidth / 2 - target.headerStyle.strokeWidth / 2,
    ...target.headerStyle,
    hasControls: false,
    lockMovementX: true,
    lockMovementY: true,
  });
  editTextSwimLaneHorizontal.myText = new fabric.Textbox(target.label, {
    textAlign: 'center',
    hasControls: false,
    lockMovementX: true,
    lockMovementY: true,
    ...JSON.parse(JSON.stringify(target.textStyle)),
  });
  editTextSwimLaneHorizontal.myText.set({
    left: target.left + target.headerWidth / 2 + target.strokeWidth / 2,
    top: target.top + target.height / 2 + target.strokeWidth / 2,
    width: target.height - 10,
    originX: 'center',
    originY: 'center',
    angle: 270,
  });

  let clnTarget = new fabric.SwimLaneHorizontal(target);
  window.canvas.add(clnTarget);
  window.canvas.remove(target);
  window.canvas.add(editTextSwimLaneHorizontal.myRect, editTextSwimLaneHorizontal.myText);
  window.canvas.setActiveObject(editTextSwimLaneHorizontal.myText);
  editTextSwimLaneHorizontal.myText.enterEditing();
  editTextSwimLaneHorizontal.myText.hiddenTextarea.focus();
  editTextSwimLaneHorizontal.myText.selectAll();
  editTextSwimLaneHorizontal.object = clnTarget;
};
